// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67d1e132","453":"90ef54ce","455":"834ad541"}[chunkId] + ".chunk.js";
};